<template>
  <div>
  <div v-if="showDetails === 'all'">
    <div class="cashbox-searcher container container_30 fields-wrap search">
      <div class="row">
        <div class="input-wrap">
          <SelectField3 :label="i18n.lbl_asset()" v-model="token" :values="tokensCodeFormatted" clear/>
        </div>
        <div class="input-wrap">
          <SelectField :label="i18n.lbl_status()" v-model="status" :values="requestStates" clear/>
        </div>
        <div class="input-wrap">
          <InputField :label="i18n.lbl_requestor_id_or_email()" v-model.trim="id" clear/>
        </div>
      </div>
      <div class="row">
        <div class="input-wrap date-wrap">
          <date-field-flatpickr :label="i18n.lbl_start_date()" v-model="date.from" title="Choose before this date" clearable/>
        </div>
        <div class="input-wrap">
          <SelectField :label="i18n.lbl_my()" v-model="level" :values="requestApproval"/>
        </div>
  
        <div class="input-wrap date-wrap">
          <date-field-flatpickr :label="i18n.lbl_end_date()" v-model="date.to" title="Choose before this date" clearable/>
        </div>
      </div>
      <div class="buttons">
        <md-button class="btn md-primary search-btn" @click="search">{{ i18n.lbl_search_btn() }}</md-button>
        <md-button class="btn md-primary md-yellow search-btn" v-if="approversList && canDelegate" @click="toggleModal">{{ i18n.lbl_delegate_btn() }}</md-button>
        <md-button v-if="foramatedDeletatedList.length" class="btn md-primary search-btn" @click="showHistory">{{ i18n.lbl_history_btn() }}</md-button>
      </div>
      <template v-if="formatedMyDelegationList.length">
      
        <div class="banner" v-for="(item, index) in formatedMyDelegationList" :key="`my-${index}`">
          <p>{{ i18n.lbl_delegate_text() }} - {{ item.approver_email }} {{ item.delegate_from }} - {{ item.delegate_to }}</p>
          <md-button class="btn md-primary md-yellow" v-if="delegated.can_delegate_revoke" @click="cancelDelegate(item.id)" :disabled="isLoading">{{ i18n.lbl_return_btn() }}</md-button>
        </div>
      </template>
      <template v-if="delegatedToMyList.length">
        <div class="banner banner-green" v-for="(item, index) in delegatedToMyList" :key="`tome${index}`">
          <p>{{ i18n.lbl_delegated_to_you({
            user: item.delegator_email,
            level: item.delegator_level_at_time,
            date: formatTimestamp(item.delegate_to)
          }) }}</p>
        </div>
      </template>
    </div>
   
    <md-table class="cashbox-list__table container container_30">
      <template v-if="!isLoading">
        <md-table-row class="cashbox-list_row">
          <md-table-head>{{ i18n.trd_order_wdrawal() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_destination_amount() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_status() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_requestor() }}</md-table-head>
          <md-table-head>{{ i18n.topup_creation_date() }}</md-table-head>
        </md-table-row>
        <template v-for="article in formatAtricles">
          <md-table-row class="cashbox-list__row table-row" :class="{'grey': article.old_asset.endsWith('20D')}" :key="article.id" @click="openDetails(article)">
            <md-table-cell class="cashbox-list__table-cell source-cell">
              {{ article.amount }} {{ article.asset }}
            </md-table-cell>
            <md-table-cell class="cashbox-list__table-cell destination-cell">
              {{ article.amount }} {{ article.asset }}
            </md-table-cell>
            <md-table-cell class="status-cell cashbox-list__table-cell capitalize"
            :class="{'green': article.status === i18n.lbl_confirmed(), 
            'yellow': article.status === i18n.lbl_pending() || article.status === i18n.lbl_check_sign() || article.status === i18n.lbl_check_sign_again(), 
            'red': article.status === i18n.lbl_canceled()}">
              {{ article.status }}
            </md-table-cell>
            <md-table-cell class="cashbox-list__table-cell requestor-cell"
              >{{ article.email  === '' ? article.user_id : article.email }}</md-table-cell
            >
            <md-table-cell class="cashbox-list__table-cell date-cell"
              >{{ article.created_formated }}</md-table-cell
            >
          </md-table-row>
        </template>
      </template>
      <template v-else-if="isLoading">
        <div class="cashbox-list__no-withdraws">
          <p>{{ i18n.lbl_loading() }}</p>
        </div>
      </template>
      <template v-else>
        <div class="cashbox-list__no-withdraws">
          <md-icon class="md-size-4x">local_atm</md-icon>
          <h2>{{ i18n.withdraw_no_withdrawals() }}</h2>
          <br />
          <p>{{ i18n.withdraw_no_withdrawals_desc() }}</p>
        </div>
      </template>
    </md-table>
    <div class="center" v-if="more">
      <md-button class="md-button md-theme-default" @click="showMore" :disabled="isLoading">{{ i18n.lbl_more() }}</md-button>
    </div>
  </div>
  <div v-else-if="showDetails === 'details'"> 
    <div class="cashbox-details container container_30">
      <div class="md-title detail-title">
        <md-button class="cashbox-details__back-btn md-icon-button" @click="closeDetails">
          <md-icon>keyboard_arrow_left</md-icon>
          <md-tooltip md-direction="top">{{ i18n.lbl_go_back() }}</md-tooltip>
        </md-button>
        <span>{{ i18n.sale_tab_details() }}</span>
      </div>
      <div class="details" v-for="(value, key, index) in opened" :key="`detail-${index}`">
        <detail :prop="key" :value="value" :copiable="(index >= 3 && index < 5) || index === 0 || index === 2"/>
      </div>
      <CheckSignList @getIds="getIds" :isRegected="selected.status === 'Rejected'" :id="selected.id"/>
      <div class="buttons" >
          <template v-if="canSign">
            <md-button class="md-button btn md-primary md-theme-default" @click="approve(opened.ID)" :disabled="isActionLoading">{{ i18n.lbl_confirm() }}</md-button>
            <md-button class="md-button btn md-primary md-theme-default" @click="cancel(opened.ID, opened.Asset)" :disabled="isActionLoading">{{ i18n.lbl_reject() }}</md-button>
          </template>
          <template v-else>
            <md-button class="md-button btn md-primary md-theme-default" @click="closeDetails">{{ i18n.lbl_cancel() }}</md-button>
          </template>
        </div>
    </div>
  </div>
  <div v-else>
    <div class="container container_30 fields-wrap">
      <div class="md-title detail-title">
        <md-button class="cashbox-details__back-btn md-icon-button" @click="closeHistory">
          <md-icon>keyboard_arrow_left</md-icon>
          <md-tooltip md-direction="top">{{ i18n.lbl_go_back() }}</md-tooltip>
        </md-button>
        <span>{{ i18n.lbl_all_history() }}</span>
      </div>
      <div class="h-block h-titles">
        <h3 class="h-detail">{{ i18n.lbl_from() }}</h3>
        <div class="h-detail"></div>
        <h3 class="h-detail">{{ i18n.lbl_to() }}</h3>
        <h3 class="h-detail">{{ i18n.lbl_created_at() }}</h3>
        <h3 class="h-detail">{{ i18n.lbl_start_date() }}</h3>
        <h3 class="h-detail">{{ i18n.lbl_end_date() }}</h3>
        <h3 class="h-detail">{{ i18n.lbl_revoked() }}</h3>
      </div>
      <div class="h-block" v-for="(item, index) in foramatedDeletatedList" :key="`history-${index}`">
        <p class="h-detail">{{ item.delegator_email }} ({{ item.delegator_level_at_time }})</p>
        <div class="h-detail">
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4"/>
          </svg>
        </div>
        <p class="h-detail">{{ item.approver_email }} ({{ item.approver_level_at_time }})</p>
        <p class="h-detail">{{ item.created_at }}</p>
        <p class="h-detail">{{ item.delegate_from }}</p>
        <p class="h-detail">{{ item.delegate_to }}</p>
        <p class="h-detail" v-if="item.is_revoked">
          <md-tooltip md-direction="top">{{ item.revoked_at }}</md-tooltip>
          <img src="/static/img/level-cross.svg"/>
        </p>
        <p class="h-detail" v-else>
          <img src="/static/img/level-success.svg"/>
        </p>
      </div>
      <div class="center" v-if="moreDelegate">
        <md-button class="md-button md-theme-default" @click="showMoreDelegate" :disabled="isLoading">{{ i18n.lbl_more() }}</md-button>
      </div>
    </div>
  </div>
  <DelegateModal v-if="modal" :active="modal" :approvers="approvers" :error="delegateError"
  @delegate="delegate" @close="closeDelegate" @clearErr="delegateError = null"/>
</div>
</template>

<script>
/* eslint-disable */
import { i18n } from '@js/i18n'
import SelectField from '@com/fields/SelectField'
import SelectField3 from '@com/fields/SelectField3'
import InputField from '@com/fields/InputField'
import DateFieldFlatpickr from '../../common/fields/DateFieldFlatpickr.vue'
import { mapGetters, mapActions } from 'vuex'
import { vuexTypes } from '@vuex/types'
import { withdrawUSDTService } from '@api/withdraw_usdt.service'
import { CRYPTO_CURRENCYS } from '@utils/consts'
import { accountsService } from '@api/accounts.service'
import CurrencyRound from '@com/mixins/currency.round.mixin'
import apiHelper from '@utils/cunstomInterseptor'
import axios from 'axios'
// import generateSignedWithdrawalJSON from '@utils/signWidrawal'
import DelegateModal from './DelegateModal'
import CheckSignList from './CheckSignList'
import DetailsMixin from '../history/index/components/details.mixin'
import { vueRoutes } from '@router/const'

export default {
  data: _ => ({
    i18n,
    isLoading: false,
    isActionLoading: false,
    id: null,
    showDetails: 'all',
    modal: false,
    token: '',
    status: '',
    articles: [],
    more: false,
    moreDelegate: false,
    approvers: [],
    deletatedList: [],
    offset: 0,
    delegateOffset: 0,
    level: '',
    date: {
      to: '',
      from: ''
    },
    opened: null,
    selected: null,
    delegated: null,
    delegateError: null,
    myDelegationList: [],
    delegatedToMyList: [],
    signerIds: []
  }),
  mixins: [CurrencyRound, DetailsMixin],
  components: {SelectField, InputField, DateFieldFlatpickr, DelegateModal, CheckSignList, SelectField3},
  created () {
    if (!this.approverData.approval_level || this.accountBlocked) {
      this.$router.push(vueRoutes.app)
    }
  },
  async mounted () {
    this.level = this.i18n.lbl_mine()
    let articles = await this.setData()
    let approvers = await this.setApprovers()
    let delegated = await this.getDelegated()
    this.deletatedList = await this.getDelegatedList(this.delegateOffset)
    this.delegatedToMyList = await this.getGivenDelegations()
    this.myDelegationList = await this.getMyDelegationList()
    this.articles = [...articles]
    this.approvers = [...approvers]
    this.delegated = delegated
    this.more = this.articles.length >= 10 && !this.isLoading
    this.moreDelegate = this.deletatedList.length >= 10 && !this.isLoading
  },
  computed: {
    ...mapGetters([
      vuexTypes.userAcquiredTokens,
      vuexTypes.accountId,
      vuexTypes.accountSeed,
      vuexTypes.userEmail,
      vuexTypes.approverData,
      vuexTypes.accountBlocked
    ]),
    tokens () {
      return this.userAcquiredTokens.map(token => token.code).filter(el => !el.endsWith('20D'))
    },
    tokensCodeFormatted () {
      if (this.tokens) {
        return this.tokens.map(el => {
          if (el.startsWith('USDT')) {
            return {key: el, val: el.replace(/^USDT/, 'USDT ')}
          }
          return {key: el, val: el}
        })
      }
      return []
    },
    approversList () {
      if (this.delegated) {
        return this.approvers.length
      }
      return false
    },
    canDelegate () {
      if (this.delegated) {
        return this.delegated.can_delegate
      }
      return false
    },
    requestStates () {
      return [this.i18n.lbl_confirmed(), this.i18n.lbl_canceled(), this.i18n.lbl_check_sign()]
    },
    requestApproval () {
      return [this.i18n.lbl_all(), this.i18n.lbl_mine()]
    },
    foramatedDeletatedList () {
      if (this.deletatedList.length) {
        return this.deletatedList.map(el => {
          return {
            ...el,
            created_at: this.toValidDate(el.created_at),
            delegate_from: this.formatTimestamp(el.delegate_from),
            delegate_to: this.formatTimestamp(el.delegate_to),
            revoked_at: this.toValidDate(el.revoked_at)
          }
        })
      }
      return []
    },
    formatedMyDelegationList () {
      if (this.myDelegationList.length) {
        return this.myDelegationList.map(el => {
          return {
            ...el,
            created_at: this.formatTimestamp(el.created_at),
            delegate_from: this.formatTimestamp(el.delegate_from),
            delegate_to: this.formatTimestamp(el.delegate_to)
          }
        })
      }
      return []
    },
    currentStatus () {
      switch (this.status) {
        case this.i18n.lbl_confirmed():
          return 'confirmed'
        case this.i18n.lbl_canceled():
          return 'canceled'
        case this.i18n.lbl_check_sign(): 
          return 'check_sign'
      }
    },
    canSign () {
      if (this.opened && this.delegated) {
        const arr = Object.values(this.delegatedToMyList.map(el => el.delegator_level_at_time))
        return (this.delegated.approver_level === this.selected.current_approval_level || arr.find(el => el === this.selected.current_approval_level)) 
        && this.selected.status == 'check_sign' && !this.signerIds.includes(this.accountId)
      }
      return false
    },
    formatAtricles () {
      if (this.articles.length) {
        return this.articles.map(el => {
          let amount = el.amount
          if (Object.values(CRYPTO_CURRENCYS).includes(el.asset) || el.asset.endsWith('20D')) {
            amount = el.asset.includes('ERC') || el.asset.includes('TRC') ? Number(el.amount) / 1000000 :
            Number(el.amount)
          }
          return {
            ...el,
            status: this.formatStatus(el.status),
            created_formated: this.i18n.d(el.created_at),
            amount: this.roundCurrency2(amount), 
            asset: this.formatAsset(el.asset),
            old_asset: el.asset
          }
        })
      }
      return this.articles
    }
  },
  methods: {
    ...mapActions({
      loadAccount: vuexTypes.GET_ACCOUNT_DETAILS,
      setApproverData: vuexTypes.setApproverData
    }),
    getIds (data) {
      this.signerIds = data
    },
    toValidDate (date) {
      const d = new Date(date)
      const userLocale = navigator.language;
      const timeParts = new Date(date).toLocaleString(userLocale, {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })
      const yy = String(d.getFullYear()).slice(-2);
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');

      return `${yy}-${mm}-${dd} ${timeParts}`;
    },
    async refreshStatuses () {
      const { data } = await axios.post(`${process.env.USDT_LISTENER_SERVER}/auth/login`, {seed: this.accountSeed})
      // eslint-disable-next-line
      this.setApproverData({couldDelegate: data.active, sign_key: data.sign_key, 
      // eslint-disable-next-line
      approval_level: data.approval_level, role: data.role, token: data.token})
      sessionStorage.setItem('token', data.token)
      this.delegated = await this.getDelegated()
      this.deletatedList = await this.getDelegatedList(this.delegateOffset)
      this.delegatedToMyList = await this.getGivenDelegations()
      this.myDelegationList = await this.getMyDelegationList()
    },
    toggleModal () {
      this.modal = true
    },
    closeDelegate () {
      this.modal = false
    },
    async getDelegated () {
      try {
        const { data } = await withdrawUSDTService.isDelegated()
        if (data) {
          return data
        }
        return []
      } catch (err) {
        console.log(err)
        return null
      } 
    },
    async getMyDelegationList () {
      try {
        const { data } = await withdrawUSDTService.getCurrentDelegationList()
        if (data) {
          return data
        }
        return []
      } catch (err) {
        console.log(err)
        return []
      } 
    },
    async getGivenDelegations () {
      try {
        const { data } = await withdrawUSDTService.getToMeDelegationList()
        if (data) {
          return data
        }
        return []
      } catch (err) {
        console.log(err)
        return []
      } 
    },
    async getDelegatedList (offset = 0) {
      try {
        const { data } = await withdrawUSDTService.getDelegatedList(offset)
        if (data) {
          return data
        }
        return []
      } catch (err) {
        console.log(err)
        return []
      } 
    },
    async cancel (id, asset) {
      try {
        this.isActionLoading = true
        await apiHelper.put(`/cancel_pending_withdrawal`, {
          network: asset,
          pending_withdrawal_id: id,
          approval_level: this.approverData.approval_level === this.selected.current_approval_level ? this.approverData.approval_level
          : this.delegatedToMyList.find(el => el.delegator_level_at_time === this.selected.current_approval_level).delegator_level_at_time || 0 
        })
      } catch (err) {
        console.log(err)
      } finally {
        await this.setData()
        this.isActionLoading = false
        this.closeDetails()
      }
    },
    async delegate (data) {
      try {
        this.delegateError = null
        const user = this.approvers.find(el => el.approver_email === data.email)
        const { to, from } = this.formatDateRangeToTimestamps(data.from, data.to)
        const params = {
          'approver_id': user.approver_id,
          'active': false,
          'x': 'init',
          'y': 'init',
          'id': this.delegated.id,
          'delegate_from': from,
          'delegate_to': to
        }
        await withdrawUSDTService.delegate(params)
        await this.refreshStatuses()
        this.closeDelegate()
      } catch(err) {
        this.delegateError = err.response.data
      }
    },
    async cancelDelegate (id) {
      try {
        this.isLoading = true
        await withdrawUSDTService.cancelDelegate(id)
        await this.refreshStatuses()
      } catch(err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    async approve (id) {
      try {
        this.isActionLoading = true
        await apiHelper.put(`/confirm_pending_withdrawal`, { pending_withdrawal_id: id, 
          approval_level: this.approverData.approval_level === this.selected.current_approval_level ? this.approverData.approval_level
        : this.delegatedToMyList.find(el => el.delegator_level_at_time === this.selected.current_approval_level).delegator_level_at_time || 0 })
      } catch (err) {
        console.log(err)
      } finally {
        await this.setData()
        this.isActionLoading = false
        this.closeDetails()
      }
    },
    async search () {
      const lvl = this.level === this.i18n.lbl_mine() ? 'my' : 'all' 
      try {
        let articles = await this.setData(10, 0, this.currentStatus, this.token, this.formatDateRangeToTimestamps(this.date.from, this.date.to), this.id,
        lvl)
        this.articles = [...articles]
        this.more = this.articles.length >= 10
      } catch(err) {
        console.log(err)
        this.articles = []
      } finally {
        this.isLoading = false
      }
    },
    async showMore () {
      this.offset += 10
      let length = this.articles.length
      const lvl = this.level === this.i18n.lbl_mine() ? 'my' : 'all' 
      try {
        let articles = await this.setData(10, this.offset, this.currentStatus, this.token, this.formatDateRangeToTimestamps(this.date.from, this.date.to), this.id, lvl)
        this.articles = [...this.articles, ...articles]
        this.more = this.articles.length > length
      } catch(err) {
        console.log(err)
        this.articles = [...this.articles]
        this.more = false
      }
    },
    async showMoreDelegate () {
      this.delegateOffset += 10
      let length = this.deletatedList.length
      try {
        let list = await this.getDelegatedList(this.delegateOffset)
        this.deletatedList = [...this.deletatedList, ...list]
        this.moreDelegate = this.deletatedList.length > length
      } catch(err) {
        console.log(err)
        this.deletatedList = [...this.deletatedList]
        this.moreDelegate = false
      }
    },
    async setApprovers () {
      try {
        this.isLoading = true
        const { data } = await withdrawUSDTService.getApproversList()
        if (data) {
          return data
        }
        return []
      } catch(err) {
        return []
      } finally {
        this.isLoading = false
      } 
    },
    async setData (limit = 10, offset = 0, status = '', asset = '', date = {to: '', from: ''}, id = '', levels = 'my') {
      const params = {limit, status, asset, date, id, offset, levels}
      try {
        this.isLoading = true
        const { data } = await withdrawUSDTService.getApprowalsWithdrawalList(params)
        if (data) {
          return data
        }
        return []
      } catch(err) {
        return []
      } finally {
        this.isLoading = false
      } 
    },
    formatAsset (asset) {
      return asset.startsWith('USDT') ? asset.replace(/^USDT/, 'USDT ').replace(/(?<=20)D$/, '') : asset
    },
    async openDetails (details) {
      await this.loadAccount()
      if (this.accountBlocked) {
        this.$router.push(vueRoutes.app)
        return
      }
      const { data } = await withdrawUSDTService.getPendingById(details.id)
      this.selected = {...details, 
        approval_level: data.approval_level, 
        current_approval_level: data.current_approval_level,
        status: data.status
      }
      let email = await accountsService.loadEmailByAccountId(details.user_id)
      this.opened = {
        'ID': details.id,
        [this.i18n.lbl_created_at()]: details.created_formated,
        [this.i18n.lbl_user_id()]: details.user_id,
        [this.i18n.lbl_email()]: email,
        [this.i18n.lbl_wallet()]: details.wallet,
        [this.i18n.lbl_asset()]: this.formatAsset(details.asset),
        [this.i18n.lbl_amount()]: `${this.roundCurrency2(details.amount)} ${this.formatAsset(details.asset)}`,
        [this.i18n.lbl_status()]: this.formatStatus(data.status),
        [this.i18n.lbl_current_lvl()]: data.current_approval_level,
        [this.i18n.lbl_total_levels()]: data.approval_level
      }
      this.showDetails = 'details'
    },
    closeDetails () {
      this.opened = null
      this.selected = null
      this.showDetails = 'all'
    },
    showHistory () {
      this.showDetails = 'history'
    },
    closeHistory () {
      this.showDetails = 'all'
    },
    formatTimestamp(isoString) {
      const date = new Date(isoString);

      const yy = String(date.getUTCFullYear()).slice(-2);
      const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
      const dd = String(date.getUTCDate()).padStart(2, '0');
      const hh = String(date.getUTCHours()).padStart(2, '0');
      const min = String(date.getUTCMinutes()).padStart(2, '0');
      const sec = String(date.getUTCSeconds()).padStart(2, '0');

      return `${yy}-${mm}-${dd} ${hh}:${min}:${sec}`;
    },
    formatDateRangeToTimestamps (startDate, endDate) {
      let from = ''
      let to = ''
      if (startDate) {
        from = `${startDate}T00:00:00Z`
      }
      if (endDate) {
        to = `${endDate}T23:59:59Z`
      }
      return {
        to,
        from
      }
    },
    formatStatus (status) {
      switch (status) {
        case 'confirmed':
          return this.i18n.lbl_confirmed()
        case 'canceled':
          return this.i18n.lbl_canceled()
        case 'check_sign':
          return this.i18n.lbl_check_sign()
      }
    },
  }
};
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';
  .detail-title {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
  }
  .h-titles {
    margin-top: 15px;
    margin-bottom: 20px;
  }
  .container_30 {
    padding-right: 60px;
  }
  .h-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .h-detail {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 20%;
      width: 20%;
      overflow-wrap: anywhere;
      &:last-child {
        width: 10%;
        max-width: 10%;
      }
      &:nth-child(2) {
        width: 5%;
        max-width: 5%;
      }
      img {
        max-width: 25px;
      }
    }
  }
  .banner {
    color: $bright-grey;
    padding: 5px 10px;
    background-color: $error-red;
    border-radius: 10px;
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .banner-green {
    background-color: $green;
  }
.buttons {
  margin-top: 10px;
  display: flex;
  gap: 15px;
}
.details {
  display: flex;
  gap: 30px;
  margin-top: 10px;
}
.search {
  margin-bottom: 24px;
}
.table-row {
  cursor: pointer;
}
.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .input-wrap {
    min-width: 400px;
  }
  .date-wrap {
    display: flex;
    &:last-child {
      justify-content: end;
    }
  }
}
.search-btn {
  width: 100%;
}
.margin-top-15 {
  margin-top: 15px;
}
.center {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.yellow {
  color: $col-pending;
}
.green {
  color: $green;
}
.red {
  color: $error-red;
}
/deep/ .md-field {
  margin-top: 0px !important;
  margin-bottom: 15px !important;
}
.grey {
    background-color: $gray_asset;
  }
</style>


// WEBPACK FOOTER //
// src/vue/app/widrawalRequest/WidrawalRequest.Index.vue